import { render, staticRenderFns } from "./BExpansionTableDirections.vue?vue&type=template&id=4c313f5d&"
import script from "./BExpansionTableDirections.vue?vue&type=script&lang=js&"
export * from "./BExpansionTableDirections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports